module.exports = __webpack_public_path__ + "img/roger.ccb2661b.svg";